import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { AuthGuard } from '@noammazuz/vzn-feathers';
import { SitesPageComponent } from './pages/sites-page/sites-page.component';
import { SiteDetailsPageComponent } from './pages/site-details-page/site-details-page.component';
import { MailListTableComponent } from './pages/mail-list-table/mail-list-table.component';
import { MailListDetailsComponent } from './pages/mail-list-details/mail-list-details.component';
import { EmailTableComponent } from './pages/email-table/email-table.component';
import { EmailDetailsComponent } from './pages/email-details/email-details.component';
import { SiteComponent } from './pages/site/site.component';
import { AdminGuard } from './guards/admin.guard';
import { P404Component } from './pages/p404/p404.component';
import { LogTableComponent } from './pages/log-table/log-table.component';

const routes: Routes = [
  { path: 'log-table', component: LogTableComponent, canActivate: [ AuthGuard, AdminGuard ]},
  { path: 'email-table', component: EmailTableComponent, canActivate: [ AuthGuard, AdminGuard ]},
  { path: 'email-details/:id', component: EmailDetailsComponent, canActivate: [ AuthGuard, AdminGuard ] },
  { path: 'mail-list-table', component: MailListTableComponent, canActivate: [ AuthGuard, AdminGuard ]},
  { path: 'mail-list-details/:id', component: MailListDetailsComponent, canActivate: [ AuthGuard, AdminGuard ] },
  { path: 'sites', component: SitesPageComponent, canActivate: [ AuthGuard, AdminGuard ] },
  { path: 'site-details/:id', component: SiteDetailsPageComponent, canActivate: [ AuthGuard, AdminGuard ] },
  { path: 'login', component: LoginPageComponent, pathMatch: 'full', data: { fullscreen: true }, canActivate: [ AdminGuard ] },
  { path: '404', component: P404Component },
  { path: ':sitePath', component: SiteComponent },
  { path: '', redirectTo: '404', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
